import { Link } from '@compat/router';
import './index.scss';
import type { FC } from 'react';
import { observer } from 'mobx-react';
import { twcls } from '@utils/twcls';

interface AuthFormPolicyDisclaimerProps {
  btnTitle: string;
  className?: string;
  isBarMenu?: boolean;
}

const AuthFormPolicyDisclaimer: FC<AuthFormPolicyDisclaimerProps> = ({
  btnTitle,
  className,
  isBarMenu
}) => (
  <div className={twcls('AuthFormPolicyDisc', className)}>
    {isBarMenu ? 'Авторизуясь, ' : `Нажимая кнопку «${btnTitle}»,`}
    <br />
    вы принимаете условия{' '}
    <Link
      className='AuthForm__link'
      to='/license-agreement'
      target='_blank'
      rel='noopener noreferrer'
    >
      Пользовательского соглашения
    </Link>{' '}
    и{' '}
    <Link
      className='AuthForm__link'
      to='/confidential'
      target='_blank'
      rel='noopener noreferrer'
    >
      Политики конфиденциальности
    </Link>{' '}
    и даете{' '}
    <Link
      className='AuthForm__link'
      to='/pdn'
      target='_blank'
      rel='noopener noreferrer'
    >
      Согласие на обработку персональных данных
    </Link>
  </div>
);

export default observer(AuthFormPolicyDisclaimer);
